import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from './SlidesServices.module.scss';
import PathContext from '../../context/path';
import StateContext from '../../context/state';
const SlidesServices = () => {
	const path = useContext(PathContext);
	const state = useContext(StateContext);
	const { updateAllStages, stage, updateStage, updatePlayPopup, transition } =
		state;
	const refSlides = useRef(null);
	const [currentStage, setCurrentStage] = useState(-1);
	const [reverse, setReverse] = useState(false);
	useEffect(() => {
		const slides = refSlides.current.children;
		let countArray = [];
		let counter = 0;
		for (const child of slides) {
			if (!child.classList.contains(styles.slide_mobile)) {
				child.dataset.slide = counter;
				countArray.push(child);
				counter++;
			}
		}
		updateAllStages(countArray.length);
	}, [updateAllStages]);

	useEffect(() => {
		let diff = currentStage > stage;
		if (!transition && diff) {
			setReverse(true);
		} else {
			setReverse(false);
		}
	}, [currentStage, stage, transition]);
	useEffect(() => {
		let diff = currentStage - stage;
		let timer = null;
		if (diff !== 0) {
			const slides = Array.from(refSlides.current.children);
			const prevSlide = slides.filter((item) =>
				item.classList.contains(styles.active)
			);
			if (prevSlide[0] !== undefined) {
				setTimeout(() => {
					prevSlide[0].classList.remove(styles.active);
				}, 500);
				const orderList = prevSlide[0].querySelectorAll(
					'[data-animation-order]'
				);
				if (orderList.length > 0) {
					orderList.forEach((element) => {
						element.classList.remove(styles.shown);
					});
				}
			}
		}
		if (reverse && !transition) {
			setCurrentStage(stage);
		}
		if (diff < 0) {
			timer = setTimeout(() => {
				setCurrentStage(stage);
			}, 500);
		}
		return () => {
			// clearInterval(prevTimer);
			clearInterval(timer);
		};
	}, [stage, currentStage, reverse, transition]);

	useEffect(() => {
		const slides = Array.from(refSlides.current.children);
		const currentSlide = slides.filter(
			(item) => parseInt(item.dataset.slide, 10) === currentStage
		);
		if (currentSlide[0] !== undefined) {
			const orderList = currentSlide[0].querySelectorAll(
				'[data-animation-order]'
			);
			currentSlide[0].classList.add(styles.active);
			if (orderList.length > 0) {
				orderList.forEach((element) => {
					setTimeout(() => {
						element.classList.add(styles.shown);
					}, element.dataset.animationOrder * 150);
				});
			}
		}
		// console.log(currentStage);
	}, [currentStage]);

	return (
		<>
			<div className={styles.wrap} ref={refSlides}>
				<div className={`${styles.slide} ${styles.slide_0}`}>
					<div className={styles.container}>
						<h1 className={styles.h1} data-animation-order={0}>
							<span>География </span>
							<span>перевозок</span>
						</h1>
						<div className={styles.text} data-animation-order={1}>
							<span>ОТЛК ЕРА </span>
							<span>предоставляет </span>
							<span>комплекс </span>
							<span>транспортно-</span>
							<span>логистических </span>
							<span>услуг </span>
							<span>по перевозке </span>
							<span>контейнеров </span>
							<span>отправителя </span>
							<span>в составе </span>
							<span>регулярных </span>
							<span>контейнерных </span>
							<span>поездов </span>
							<span>на маршрутах </span>
							<span>ж/д коридора </span> 
							<span>«Восток—Запад»</span>
						</div>
						<div className={styles.btn} data-animation-order={2}>
							<img src={`${path}/img/icon-hand.svg`} alt='' />
							<div className={styles.btn__text}>
								<div className={styles.btn__inner}>
									Свайп вправо для навигации
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className={`${styles.slide} ${styles.slide_1}`}>
					<div className={styles.container}>
						<div className={styles.col}>
							<h3 className={styles.h3} data-animation-order={1}>
								<span>Транзитные</span>
								<span> перевозки</span>
							</h3>
						</div>
						<div className={styles.col}>
							<div className={styles.text} data-animation-order={0}>
								<span>Перевозки </span>
								<span>контейнеров </span><br />
								<span>по коридору </span>
								<span>«Восток—Запад» </span> <br />
								<span>через </span>
								<span>территории </span>
								<span>Казахстана, </span>
								<span>России </span>
								<span>и Беларуси</span>
							</div>
						</div>
					</div>
				</div>

				<div className={`${styles.slide} ${styles.slide_2}`}>
					<div className={styles.container}>
						<h2 className={styles.h2} data-animation-order={0}>
							<span>200+ </span>
							<span>локаций </span>
							<span>в Китае </span>
							<span>и Европе</span>
						</h2>
					</div>
				</div>

				<div className={`${styles.slide} ${styles.slide_3}`}>
					<div className={styles.container}>
						<h2 className={styles.h2} data-animation-order={0}>
							<span>600+ </span>
							<span>маршрутов</span>
						</h2>
					</div>
				</div>

				<div className={`${styles.slide} ${styles.slide_4}`}>
					<div className={styles.container}>
						<h2 className={styles.h2} data-animation-order={0}>
							<span>20–30 </span>
							<span>поездов </span>
							<span>отправляются </span>
							<span>ежедневно</span>
						</h2>
					</div>
				</div>

				<div className={`${styles.slide} ${styles.slide_5}`}>
					<div className={styles.container}>
						<h2 className={styles.h2} data-animation-order={0}>
							<span>5–7 </span>
							<span>суток </span>
							<span>занимает </span>
							<span>перевозка </span>
							<span>между </span>
							<span>границами </span>
							<span>c Китаем </span>
							<span>и ЕС</span>
						</h2>
					</div>
				</div>

				<div className={`${styles.slide} ${styles.slide_6}`}>
					<div className={styles.container}>
						<h3 className={styles.h3} data-animation-order={0}>
							<span>Мультимодальные </span>
							<span>перевозки </span>
							<span>через </span>
							<span>Калининград</span>
						</h3>
						<div className={styles.text} data-animation-order={1}>
							<span>ОТЛК ЕРА </span>
							<span>совместно </span>
							<span>с партнёрами </span>
							<span>организует </span>
							<span>мультимодальные </span>
							<span>перевозки </span> <br />
							<span>(ж/д — море) </span>
							<span>через </span>
							<span>Калининградский </span>
							<span>морской </span>
							<span>торговый </span>
							<span>порт </span>
							<span>в направлении </span>
							<span>стран Северной </span>
							<span>Европы и Скандинавии</span>
						</div>
					</div>
				</div>

				<div className={`${styles.slide} ${styles.slide_7}`}>
					<div className={styles.container}>
						<div className={styles.col}>
							<h3 className={styles.h3} data-animation-order={0}>
								<span>Перевозки </span>
								<span>из Китая</span>
							</h3>
						</div>
						<div className={styles.col}>
							<div className={styles.text} data-animation-order={0}>
								<span>Маршруты </span>
								<span>из Китая </span>
								<span>через </span>
								<span>погранпереходы </span>
								<span>Достык и Алтынколь </span>
								<span>в Беларусь и Россию. </span>
								<span>Локации </span>
								<span>поглощения грузов </span>
								<span>расположены </span>
								<span>в Москве, </span>
								<span>Санкт-Петербурге </span>
								<span>и других российских </span>
								<span>регионах, </span>
								<span>а также </span>
								<span>в Беларуси</span>
							</div>
						</div>
					</div>
				</div>

				<div className={`${styles.slide} ${styles.slide_8}`}>
					<div className={styles.container}>
						<h2 className={styles.h2} data-animation-order={0}>
							<span>26 </span>
							<span>локаций </span>
							<span>в Беларуси </span>
							<span>и России</span>
						</h2>
					</div>
				</div>

				<div className={`${styles.slide} ${styles.slide_9}`}>
					<div className={styles.container}>
						<h2 className={styles.h2} data-animation-order={0}>
							<span>4 поезда </span>
							<span>отправляются </span>
							<span>ежедневно</span>
						</h2>
					</div>
				</div>

				<div className={`${styles.slide} ${styles.slide_10}`}>
					<div className={styles.container}>
						<h2 className={styles.h2} data-animation-order={0}>
							<span>5–7 суток </span>
							<span>занимает </span>
							<span>перевозка </span>
							<span>в Россию </span>
							<span>и Беларусь</span>
						</h2>
					</div>
				</div>

				<div className={`${styles.slide} ${styles.slide_11}`}>
					<div className={styles.container}>
						<h3 className={styles.h3} data-animation-order={0}>
							<span>Работаем </span>
							<span>с 10 </span>
							<span>терминалами* </span>
							<span>в Москве</span>
						</h3>
						<div className={styles.desc} data-animation-order={1}>
							<span>Приведён </span>
							<span>суммарный </span>
							<span>объём </span>
							<span>грузов </span>
							<span>ОТЛК ЕРА </span>
							<span>в каждом </span>
							<span>терминале </span>
							<span>за 2022 год</span>
						</div>
					</div>
				</div>

				<div className={`${styles.slide} ${styles.slide_12}`}>
					<div className={styles.container}>
						<h3 className={styles.h3} data-animation-order={0}>
							<span>Работаем </span>
							<span>с 4 терминалами </span>
							<span>в Санкт-Петербурге</span>
						</h3>
					</div>
				</div>

				<div className={`${styles.slide} ${styles.slide_13}`}>
					<div className={styles.container}>
						<div className={styles.col}>
							<h3 className={styles.h3} data-animation-order={0}>
								<span>Перевозки </span>
								<span>в Китай</span>
							</h3>
						</div>
						<div className={styles.col}>
							<div className={styles.text} data-animation-order={1}>
								<span>Маршруты </span>
								<span>из России </span>
								<span>и Беларуси </span>
								<span>в Китай </span>
								<span>до погранпереходов </span>
								<span>Достык и Алтынколь. </span>
								<span>Среди </span>
								<span>регионов экспорта — Поволжье, </span>
								<span>Красноярский край, </span>
								<span>северо-западная </span>
								<span>часть России, </span>
								<span>Московская область, </span>
								<span>а также области </span>
								<span>Беларуси</span>
							</div>
						</div>
					</div>
				</div>

				<div className={`${styles.slide} ${styles.slide_14}`}>
					<div className={styles.container}>
						<h2 className={styles.h2} data-animation-order={0}>
							<span>12,7 суток </span>
							<span>занимает </span>
							<span>перевозка </span>
							<span>из России </span>
							<span>до границы </span>
							<span>с Китаем</span>
						</h2>
					</div>
				</div>

				<div className={`${styles.slide} ${styles.slide_15}`}>
					<div className={styles.container}>
						<h2 className={styles.h2} data-animation-order={0}>

							<span>11,6 суток </span>
							<span>занимает </span>
							<span>перевозка </span>
							<span>из Беларуси </span>
							<span>до границы </span>
							<span>с Китаем</span>
						</h2>
					</div>
				</div>
			</div>
		</>
	);
};

export default SlidesServices;
